const KNOWN_DISC = ['PIP', 'MWR', 'ELE', 'SHM', 'PFS', 'CIV', 'STR', 'TNK', 'BMT'];

/**
 * Label for a job + discipline pair.
 * Jobs that already end in the discipline (30437PIP + PIP) stay 30437PIP.
 * Bare job numbers (PRESO-TT-001 + PIP) become PRESO-TT-001PIP.
 */
export function formatJobDisciplineDisplay(jobNumber, disciplineCode) {
  const job = String(jobNumber || '').trim();
  const code = String(disciplineCode || '').toUpperCase().trim();
  if (!job) return code;
  if (!code) return job;
  if (job.toUpperCase().endsWith(code)) return job;
  return `${job}${code}`;
}

/**
 * Build Time Tracker project-discipline picker rows.
 * Jobs like 30437PIP often have no core.project_disciplines row — infer PIP
 * from the job suffix so Extras/Op Codes can still open them.
 */
export function buildProjectDisciplineOptions(projects = []) {
  const options = [];
  for (const project of projects) {
    const seen = new Set();
    const add = (disciplineCode) => {
      const code = String(disciplineCode || '').toUpperCase();
      if (!code || seen.has(code)) return;
      seen.add(code);
      options.push({
        project_id: project.id,
        job_number: project.job_number,
        job_name: project.job_name || '',
        discipline_code: code,
        display_value: formatJobDisciplineDisplay(project.job_number, code),
        optionKey: `${project.id}-${code}`,
      });
    };

    for (const discipline of (project.disciplines || [])) {
      add(discipline.discipline_code);
    }

    const suffix = String(project.job_number || '').match(/([A-Za-z]{3})$/);
    if (suffix && KNOWN_DISC.includes(suffix[1].toUpperCase())) {
      add(suffix[1]);
    }
  }
  return options.sort((a, b) => a.display_value.localeCompare(b.display_value));
}

export { KNOWN_DISC };
